import { React, Link } from "utils";
import "./activeevents.less";

/**
 * @return {null}
 */
export function EventCard({ data }) {
  return (
    <div className="events col-md-3">
      <div className="card">
        <Link to={"/events/" + data.id}>
          <div className="card-body">
            <div className="pavilion">{data.subtitle}</div>
            <div className="image">
              {data.image && <img alt="" src={data.image} />}
            </div>
            <div className="title-container">
              <h4>{data.title}</h4>
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
}

/**
 * @return {null}
 */
export function ActiveEvents({ data }) {
  if (data && data.length > 0) {
    let events = data.map(function(item) {
      return <EventCard key={item.id} data={item} />;
    });

    return (
      <div className="active-stands">
        <div className="row">{events}</div>
      </div>
    );
  } else {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/modules/components/activeevents.js